// extracted by mini-css-extract-plugin
module.exports = {"washingRules":"WashingRules_washingRules__fxATH","washingRuleItem":"WashingRules_washingRuleItem__KjchU","washingRuleDescription":"WashingRules_washingRuleDescription__IOXS5"};